<template>
  <b-modal
    v-model="visible"
    @hidden="
      () => {
        $emit('update:visible', false);
      }
    "
    @shown="openForm"
    :title="$t(isEmpty(data) ? 'ar_clinent_distributing_accounts' : 'ar_client_edit_distribution')"
    centered
    size="lg"
    hide-footer
  >
    <validation-observer ref="formRef">
      <form ref="form">
        <b-row class="m-0 mt-2">
          <b-col md="6">
            <b-form-group :label="$t('ar_client_agency')">
              <b-form-input :value="travelAgent" :disabled="true"></b-form-input>
            </b-form-group>
            <b-form-group style="margin-top: 26px" :label="$t('ar_client_total_money') + ' (VND)'">
              <b-form-input :value="formatPrice(totalDistribution)" :disabled="true"></b-form-input>
            </b-form-group>
            <!--  <b-form-group :label="$t('ar_clinent_total_amount_distributed') + ' (VND)'">
              <b-form-input
                :value="formatPrice(totalMoneyDistribution)"
                :disabled="true"
              ></b-form-input>
            </b-form-group> -->
          </b-col>
          <b-col md="6">
            <FormItem
              type="cleave"
              v-model="distributionCode"
              cleaveType="uppercase"
              label="ar_client_distribution_code"
              placeholder="ar_client_distribution_code"
              name="distributionCode"
              :disabled="data.DistributionCode || isAutoCreateCode"
              :rules="{
                max: 13,
                min: isAutoCreateCode ? 0 : 2,
                code: !isAutoCreateCode,
                required: !isAutoCreateCode,
              }"
            />

            <div class="d-flex align-items-center mt-2 mb-2">
              <label class="mr-1">{{ $t("ar_client_auto_create_distribution_code") }}</label>
              <b-form-checkbox
                :disabled="data.DistributionCode"
                v-model="isAutoCreateCode"
                switch
              ></b-form-checkbox>
            </div>
            <b-form-group :label="$t('ar_client_allotment') + ':'" label-cols="3">
              <div class="h-100 d-flex align-items-center">
                <b-form-radio
                  v-model="selectedDistributionType"
                  :disabled="true"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="AUTO"
                  class="mr-2"
                  >{{ $t("ar_client_auto") }}</b-form-radio
                >
                <b-form-radio
                  :disabled="disabledField"
                  v-model="selectedDistributionType"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="Manual"
                  >{{ $t("ar_client_manual") }}</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <div class="p-1">
        <FormItem
          type="string"
          variant="textarea"
          v-model="note"
          label="ar_client_note"
          placeholder="ar_client_note"
          name="note"
          :rules="{ max: 255 }"
        />
      </div>
    </validation-observer>

    <h6 class="m-2">{{ $t("ar_client_list_debit_account") }}</h6>
    <b-row class="m-0">
      <b-col md="3">
        <b-form-group :label="$t('ar_client_debit_account')">
          <v-select
            :disabled="disabledField"
            v-model="selectedValAccount"
            label="AccountCode"
            :placeholder="$t('golf_ar_select_debit_account')"
            :options="listAccountClient"
            ><div slot="no-options">{{ $t("ar_client_no_data") }}</div></v-select
          >
        </b-form-group>
      </b-col>
      <b-col md="3">
        <FormItem
          :disabled="disabledField"
          type="cleave"
          v-model="valMoney"
          cleaveType="currency"
          label="ar_client_distribution_amount"
          placeholder=" "
          name="valMoney"
          :rules="{ max: 12 }"
        />

        <div
          v-if="valMoney"
          class="text-right font-weight-bold font-italic text-primary"
          style="font-size: 10px; margin-top: 6px"
        >
          {{ numberToVnText(this.valMoney) }}
        </div>

        <!-- <b-form-input v-model="valMoney" placeholder="Số tiền"></b-form-input> -->
      </b-col>

      <b-col md="2">
        <b-button
          :disabled="disabledField"
          style="margin-top: 24px"
          variant="primary"
          @click="addListArAccount"
        >
          {{ $t("ar_client_add") }}
        </b-button>
      </b-col>
    </b-row>
    <!--  <div class="p-1 overflow-auto">
      <table class="table table-bordered p-1">
        <thead>
          <tr>
            <th scope="col">{{ $t("ar_client_account_code") }}</th>
            <th scope="col">{{ $t("ar_client_account_credit_limit") }}</th>
            <th scope="col">{{ $t("ar_client_account_credit_limit_day") }}</th>
            <th scope="col">{{ $t("ar_client_account_limit_type") }}</th>
            <th scope="col">{{ $t("ar_client_account_dedit_balances") }}</th>
            <th scope="col">{{ $t("ar_client_account_credit_balances") }}</th>
            <th scope="col">{{ $t("ar_client_account_number_surplus") }}</th>
            <th scope="col">{{ $t("ar_client_distribution_money_number") }}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in listDistributionAdded" :key="item">
            <td>{{ item.valSelected.AccountCode }}</td>
            <td>{{ formatPrice(item.valSelected.LimitType) }}</td>
            <td>{{ formatPrice(item.valSelected.CreditLimitDays) }}</td>
            <td>{{ item.valSelected.ArTypeId }}</td>
            <td>{{ formatPrice(item.valSelected.CreditBalance) }}</td>
            <td>{{ formatPrice(item.valSelected.DebitBalance) }}</td>
            <td>{{ formatPrice(item.valSelected.CreditLimit) }}</td>
            <td>{{ formatPrice(item.valMoney) }}</td>
            <td>
              <ez-icon
                icon="ezAr-icon-trash"
                size="18"
                color="#EA5455"
                class="cursor-pointer"
                @click="removeItemList(index)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <h4
        v-if="listDistributionAdded.length === 0"
        class="text-muted text-center my-4"
      >
        No Data
      </h4>
    </div> -->
    <div class="p-1">
      <EzTable
        ref="tableRef"
        :forceDisplayActions="true"
        :toolbarConfig="{ disableToolbar: true }"
        :pageConfig="{ disablePagination: true }"
        :actions="actions"
        :columns="columns"
        :editable="true"
        @onEditorPreparing="onEditorPreparing"
        :data-source="listDistributionAdded"
        @action-1="removeItemList"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <div class="d-flex align-items-center mb-2 mr-4">
        <h5 style="margin-top: 3px" class="mr-1">
          {{ $t("ar_clinent_total_amount_distributed") }} (VND) :
        </h5>
        <span style="font-size: 16px; margin-bottom: 1px">{{
          formatPrice(totalMoneyDistribution)
        }}</span>
      </div>
      <LoadingModalButton
        :usingTimeOutSubmit="true"
        ref="buttonRef"
        className=" mb-2 mr-2"
        @click="acceptData"
      >
        {{ $t("ar_common_save") }}
      </LoadingModalButton>
    </div>
  </b-modal>
</template>
<style lang="scss">
.dx-datagrid .dx-header-row td {
  text-align: center !important;
}
.dx-data-row .cell-highlighted {
  /*  background-color: red; */
  border: 2px solid #d5d6db !important;
}
</style>
<script>
import { arClient } from "@/api/ar-client";
import {
  DxColumn,
  DxRequiredRule,
  DxDataGrid,
  DxCustomRule,
  DxEditing,
  DxScrolling,
} from "devextreme-vue/data-grid";

import EzTable from "../../../ultils/Table/EzTable.vue";
import { doReadNumber, ReadingConfig } from "read-vietnamese-number";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import WidgetCleave from "../../../ultils/Form/components/Cleave/WidgetCleave.vue";
import WidgetString from "../../../ultils/Form/components/String/WidgetString.vue";
import FormItem from "../../../ultils/Form/components/FormItem/FormItem.vue";
import LoadingModalButton from "../../../ultils/Button/LoadingModalButton.vue";
import { formatPrice } from "@/@core/utils/utils";
import FormItems from "@/views/modules/ultils/Form/FormItems.vue";
import { computed, ref } from "@vue/composition-api";
export default {
  name: "ModalDistributionAccount",
  props: {
    disabled: Boolean,
    visible: {
      type: Boolean,
      default: false,
    },
    currencyCode: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },

    listDataSelected: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    LoadingModalButton,
    ValidationObserver,
    FormItem,
    EzTable,
    WidgetString,
    WidgetCleave,
    DxCustomRule,
    DxScrolling,
    DxRequiredRule,
    EzTable,
    DxColumn,
    DxEditing,
    DxDataGrid,
    FormItems,
  },

  data() {
    return {
      travelAgent: "",
      actions: [
        {
          title: "ar_common_delete",
          icon: "trash",
          direct: true,
          danger: true,
        },
      ],
      listDistributionAdded: [],
      totalDistribution: 0,

      isAutoCreateCode: false,
      listAccountClient: [],

      totalDistribution: 0,
      note: "",
      selectedValAccount: null,
      totalMoneyDistribution: 0,
      distributionCode: undefined,
      selectedDistributionType: "Manual",
      currencyCodeLocale: "",
      valMoney: 0,
      ArDistributionAccount: [],
    };
  },
  computed: {
    disabledField() {
      return this.data.Status == "CREATINGAP" || this.data.Status == "CREATEDAP";
    },
    columns() {
      return [
        {
          caption: "ar_client_debit_account_code",
          field: "AccountCode",
        },
        {
          caption: "ar_client_site_code",
          field: "PropertyName",
        },

        {
          caption: "ar_client_account_debit_balances",
          field: "DebitBalance",
          formatType: "currency",
          cellTemplate: true,
        },
        {
          caption: "ar_client_account_credit_balances",
          field: "CreditBalance",
          formatType: "currency",
          cellTemplate: true,
        },

        /*  {
          caption: this.$t("ar_client_account_number_surplus"),

          isShow: true,
          cellTemplate: "ArPaymentId",
          alignment: "center",
          width: "15%",
        }, */
        {
          caption: "ar_client_distribution_money_number",
          width: "200px",
          field: "Amount",
          formatType: "currency",
          cellTemplate: true,
          editingConfig: {
            required: true,
            rules: [
              {
                callback: this.validateAmount,
                message: "ar_client_distribution_msg_err_02",
              },
              {
                callback: (e) => e.value > 0,
                message: "ar_client_distribution_msg_err_03",
              },
            ],
          },

          cssClass: "cell-highlighted",
        },
      ];
    },
    templateArr() {
      return this.configTable.filter((c) => c.cellTemplate);
    },
  },
  methods: {
    openForm() {
      this.getListAccountClient_AR_RAA01();

      this.totalDistribution =
        this.listDataSelected.length > 0
          ? this.listDataSelected.reduce((acc, val) => {
              const temp = val.TotalAmount - val.DistributionAmount;

              acc += temp;
              return acc;
            }, 0)
          : this.data.TotalAmountDistribution + this.data.TotalAmount;

      this.setLocalCurency();
      this.note = this.data.Note;
      this.isAutoCreateCode = this.data.IsAutoGeneration;
      this.travelAgent =
        this.listDataSelected.length > 0
          ? this.listDataSelected[0].NameVi
          : this.data.ArTravelAgentName;
      this.distributionCode = this.data.DistributionCode;

      this.selectedDistributionType = this.data.DistributionType || "Manual";
    },
    /* numberToVnText(num) {
      const config = new ReadingConfig();
      config.unit = [""];
      console.log(num,typeof num,"21111")
      return doReadNumber(config, num);
    }, */
    validateAmount(e) {
      const temp = this.listDistributionAdded.filter((dis) => dis.Id !== e.data.Id);
      const tempMoneyDistributionTotal = temp.reduce((acc, val) => {
        acc += val.Amount;
        return acc;
      }, 0);

      return e.value + tempMoneyDistributionTotal <= +this.totalDistribution;
    },
    onEditorPreparing(e) {
      if (e.dataField !== "Amount") {
        e.editorOptions.disabled = true;
      }
      if (e.dataField === "Amount" && this.disabledField) {
        e.editorOptions.disabled = true;
      }
    },

    async getListAccountClient_AR_RAA01() {
      // Lấy danh sách các tài khoản của đại lý
      this.isLoading = true;

      const body = {
        InActive: 1,
        IsCheckPermission: false,
        ArTravelAgentId: this.data.ArTravelAgentId || this.listDataSelected[0].TravelAgentId,
      };

      await arClient
        .api_AR_RAA01(body)
        .then((res) => {
          if (res.Status === "200") {
            this.listAccountClient = [...res.Data.ArAccount];
            if (this.data?.ListArDistributionAccount?.length > 0) {
              this.listDistributionAdded = res.Data.ArAccount.reduce((acc, val, index) => {
                this.data.ListArDistributionAccount.forEach((item) => {
                  if (val.Id === item.AccountId) {
                    const temp = {
                      ...val,
                      Amount: item.Amount,
                      ArDistributionAccountId: item.Id,
                    };
                    const foundAccount = acc.findIndex((account) => account.Id === temp.Id);
                    if (foundAccount !== -1) {
                      acc[foundAccount]["Amount"] += temp.Amount;
                    } else {
                      acc.push(temp);
                    }
                  }
                });

                return acc;
              }, []);
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    acceptData() {
      this.$refs.formRef.validate().then((success) => {
        if (success) {
          if (this.listDistributionAdded.length <= 0) {
            this.showToast("error", this.$t("ar_client_no_account_distribution_msg"));
            return;
          }

          this.$refs.tableRef.dataGridInstance.saveEditData().then(() => {
            this.$refs.buttonRef.startLoading();
            const data = {
              ArDistribution: {
                AutoCode: this.isAutoCreateCode || false,
                PaymentDistributionCode: this.distributionCode,
                DistributionType: this.selectedDistributionType,
                Note: this.note,
                ArTravelAgentId: this.listDataSelected[0]?.TravelAgentId,
                PaymentId: this.listDataSelected.map((item) => item.Id),
              },
              ArDistributionAccount: this.listDistributionAdded.map((item) => ({
                ArAccountId: item.Id,
                Amount: +item.Amount,
                CurrencyCode: "577b715c-9b1f-42ee-9806-7a9359231fcd",
              })),
            };

            const editData = {
              ArDistribution: {
                Note: this.note,
                DistributionCode: this.distributionCode,
                DistributionType: this.selectedDistributionType,
                Id: this.data.Id,
              },
              ArDistributionAccount: this.listDistributionAdded.map((item) => ({
                Id: item.ArDistributionAccountId,
                ArAccountId: item.Id,

                Amount: +item.Amount,
              })),
            };
            this.$emit("accept-data", Object.keys(this.data).length > 0 ? editData : data);
          });
        }
      });
    },
    setLocalCurency() {
      const currencyList = JSON.parse(localStorage.getItem("userData"))?.currency;
      this.currencyCodeLocale = currencyList?.find((item) => item.IsBase)?.CurrencyCode;
    },

    addListArAccount() {
      if (!this.selectedValAccount) {
        this.showToast("error", this.$t("ar_client_distribution_msg_err_01"));
        return;
      }
      if (this.valMoney <= 0) {
        this.showToast("error", this.$t("ar_client_amount_not_smaller_than_0"));
        return;
      }
      if (this.totalMoneyDistribution + Number(this.valMoney) > Number(this.totalDistribution)) {
        this.showToast("error", this.$t("ar_client_distribution_msg_err_02"));
        return;
      }
      const foundAccountDistributionIndex = this.listDistributionAdded.findIndex(
        (acc) => acc.Id === this.selectedValAccount.Id
      );
      if (foundAccountDistributionIndex !== -1) {
        this.listDistributionAdded[foundAccountDistributionIndex]["Amount"] += this.valMoney;
      } else {
        this.listDistributionAdded.push({
          ...this.selectedValAccount,
          Amount: +this.valMoney,
        });
      }

      this.valMoney = 0;

      this.selectedValAccount = null;
    },
    resetValue() {
      this.selectedValAccount = null;
      (this.note = ""), (this.totalDistribution = 0);
      this.totalMoneyDistribution = 0;
      this.valMoney = 0;
      this.listAccountClient = [];
      this.distributionCode = undefined;
      this.currencyCodeLocale = "";
      this.listDistributionAdded = [];
    },
    removeItemList(rowData) {
      this.listDistributionAdded.splice(rowData.rowIndex, 1);
    },
  },
  watch: {
    isAutoCreateCode(value) {
      if (value && !this.data.DistributionCode) {
        this.distributionCode = "";
      }
    },
    listDistributionAdded: {
      handler: function (arr) {
        this.totalMoneyDistribution = arr.reduce((acc, val) => {
          acc += val.Amount;
          return +acc;
        }, 0);
      },
      deep: true,
    },
  },
};
</script>
